import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './auth/Login';
import Signup from './auth/Signup';
import ForgotPassword from './auth/ForgotPassword';
import MainLayout from './layout';
import CustomizerPage from './customizer/CustomizerPage';
import TearSheet from './tearsheet/TearSheet';
import CollectionsPage from './collections/CollectionsPage';
import StyleAssistantPage from './stylingAssistant/StyleAssistantPage';

const AppWrapper = () => {
  return (
    <>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route element={<MainLayout />}>
          <Route path="/customize" element={<CustomizerPage />} />
          <Route path="/tear-sheet" element={<TearSheet />} />
          <Route path="/collections" element={<CollectionsPage />} />
          <Route path="/style-assistant" element={<StyleAssistantPage />} />
        </Route>
        <Route path="/" element={<Navigate to="/customize" replace />} />
        <Route path="*" element={<Navigate to="/customize" replace />} />
      </Routes>
    </>
  );
};

export default AppWrapper;
